import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationListComponent } from '@appkit4/angular-components/notification';
import { AppNotificationService } from '@shared/services';

@Component({
  standalone: false,
  selector: 'gstar-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit {
  private readonly translateService = inject(TranslateService);
  private readonly notificationService = inject(AppNotificationService);

  @ViewChild('notificationApp')
  notification!: ElementRef<NotificationListComponent>;

  get status(): NotificationStatusType {
    return this.notificationService.currentNotificationState
      .status as NotificationStatusType;
  }

  get id(): string {
    return this.notificationService.currentNotificationState.id;
  }

  ngAfterViewInit(): void {
    this.notificationService.setGlobalNotification(
      this.notification.nativeElement
    );
  }

  ngOnInit(): void {
    this.translateService.setFallbackLang('en');
    this.translateService.use('en');
  }
}
